import React from 'react';
import NotificationsList from '../components/NotificationsList';

const Notifications = () => {
    return (
        <div>
            <NotificationsList />
        </div>
    );
};

export default Notifications;
